{
  "breadcrumb": "Dokumenter",
  "title": "Dokumenter",
  "description": "Oversikt over alle dokumenter knyttet til denne entreprenøren",
  "uploadButton": "Last opp dokument",
  "selectPeriod": "Velg periode",
  "allTypes": "Vis alle typer",
  "allStatuses": "Vis alle statuser",
  "loading": "Laster dokumenter...",
  "loadErrorMessage": "Kunne ikke laste inn dokumenter. Prøv å laste siden på nytt.",
  "columnDocument": "Dokument",
  "columnType": "Type",
  "columnStatus": "Status",
  "columnUploadedBy": "Opplastet av",
  "columnUploadedDate": "Opplastet dato",
  "statusActive": "Aktiv",
  "statusInactive": "Inaktiv",
  "actionsDownload": "Last ned",
  "actionsEdit": "Endre",
  "actionsDelete": "Slett",
  "actionsSetActive": "Sett aktiv",
  "actionsSetInactive": "Sett inaktiv",
  "editTitle": "Endre dokument",
  "uploadTitle": "Last opp nytt dokument",
  "uploadTypeLabel": "Type",
  "uploadTypePlaceholder": "Velg dokumenttype",
  "uploadFileLabel": "Last opp filer",
  "uploadFilesHelpText": "Velg dokumenttype før du velger fil.",
  "noFilesUploadedEmpty": "Ingen filer lastet opp",
  "uploadDescriptionLabel": "Beskrivelse",
  "uploadDescriptionPlaceholder": "Legg til en valgfri beskrivelse av dokumentet",
  "documentTypeRequired": "Dokumentasjonstype må velges først",
  "uploadErrorMessage": "Noe gikk galt. Prøv igjen.",
  "updateErrorMessage": "Oppdatering feilet. Prøv igjen.",
  "downloadErrorMessage": "Nedlasting feilet. Prøv igjen.",
  "deleteErrorMessage": "Sletting feilet. Prøv igjen.",
  "toggleStatusErrorMessage": "Statusendring feilet. Prøv igjen.",
  "editSaveButton": "Lagre endringer",
  "editFileLabel": "Last opp fil",
  "uploadedFilesLabel": "Opplastede filer",
  "abortDialogTitle": "Er du sikker på at du vil avbryte?",
  "abortDialogDescription": "Endringer du har gjort, inkludert opplastede filer og beskrivelser, vil ikke bli lagret.",
  "abortDialogCancel": "Fortsett redigering",
  "abortDialogAction": "Avbryt uten å lagre",
  "emptyTitle": "Ingen dokumenter",
  "emptyDescription": "Trykk på \"Last opp dokument\" for å legge til et nytt",
  "emptyFilteredTitle": "Ingen dokumenter funnet",
  "emptyFilteredDescription": "Fant ingen dokumenter som matcher valgt filter",
  "deleteFileDialogTitle": "Er du sikker på at du vil slette filen?",
  "deleteFileDialogDescription": "Denne handlingen kan ikke reverseres. Filen vil bli slettet permanent.",
  "deleteFileDialogCancel": "Avbryt",
  "deleteFileDialogAction": "Slett",
  "validationDocumentTypeRequired": "Dokumenttype må velges",
  "validationFileRequired": "Du må laste opp en fil",
  "validationFileMaxOne": "Bare én fil er tillatt",
  "validationDescriptionMaxLength": "Beskrivelsen kan ikke være mer enn 200 tegn"
}
